import { render } from "./DisplayMode.vue?vue&type=template&id=2c052f9e"
import script from "./DisplayMode.vue?vue&type=script&lang=js"
export * from "./DisplayMode.vue?vue&type=script&lang=js"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__